export const stepsSettings = {
  "settings": [
    {
      "title": "Ingresos",
      "percent": 20,
      "progress": {
        "maxPersent": 65,
        "title": "probabilidad de aprobación",
        "titlePercent": "5%",
        "footer": "por la información sobre tus ingresos",
        "footerPercent": "+20%"
      },
      "pixel": "ingresos_v2"
    },
    {
      "title": "Información personal",
      "percent": 0,
      "progress": {
        "maxPersent": 65,
        "title": "probabilidad de aprobación",
        "titlePercent": "25%",
        "footer": "por la información personal",
        "footerPercent": "+40%"
      },
      "actions": ["create"],
      "pixel": "short_v2"
    },
    {
      "title": "Domicilio",
      "percent": 10,
      "progress": {
        "maxPersent": 65,
        "title": "probabilidad de aprobación",
        "titlePercent": "65%",
        "footer": "por el domicilio",
        "footerPercent": "+10%"
      },
      "actions": ["update"],
      "pixel": "domicilio_v2"
    },
    {
      "title": "Cuenta bancaria",
      "percent": 0,
      "progress": {
        "maxPersent": 100,
        "title": "probabilidad de aprobación",
        "titlePercent": "75%",
        "footer": "por indicar tu cuenta bancaria",
        "footerPercent": "+10%"
      },
      "actions": ["update"],
      "pixel": "bank_account_v2",
      "bankSsl": true
    },
    {
      "title": "Información adicional",
      "percent": 10,
      "progress": {
        "maxPersent": 100,
        "title": "probabilidad de aprobación",
        "titlePercent": "85%",
        "footer": "por las preguntas adicional",
        "footerPercent": "+10%"
      },
      "actions": ["update"],
      "pixel": "large_v2"
    }
  ],
  "replacements": {
    "Condiciones": {
      "type": "link",
      "text": "condiciones de uso",
      "to": "/condiciones-de-uso"
    },
    "Politica": {
      "type": "link",
      "text": "política de privacidad",
      "to": "/politica-de-privacidad"
    },
    "Name": {
      "type": "variable",
      "key": "firstname1"
    },
    "Value": {
      "type": "variable",
      "key": "amount"
    }
  },
  "desktopInputLayout": ["", "2 2 2 1", "2 2 2", "", ""],
  "isOptions": ["work_since_date", "crypto_wallet"],
  "pixel": "datos_personales_v2"
}